
  import { Vue, Component, Prop } from 'vue-property-decorator'
  import uuid from 'uuid-random'
  import 'vue-slider-component/dist-css/vue-slider-component.css'
  import 'vue-slider-component/theme/default.css'

  @Component({
    components: {
      FilterLabel: () => import('~/components/atoms/labels/FilterLabel.vue'),
      VueSlider: () => import('vue-slider-component/dist-css/vue-slider-component.umd.min.js'),
    },
  })
  export default class OneRangeSliderFilter extends Vue {
    @Prop({
      required: true,
      type: String,
    })
    testId!: string

    @Prop({
      required: true,
      type: Object,
    })
    filter!: any;

    @Prop({
      type: Number,
      default: 1,
    })
    interval!: number;

    @Prop({
      default: () => [],
      type: Array,
    })
    selectedValue!: any

    name: string = 'one-input-filter'
    uuid: string = 'filter-' + uuid()
    isCollapsed: boolean = true;

    get min(): number {
      return this.filter?.min
    }

    get max(): number {
      return this.filter?.max
    }

    get selectedMin(): number {
      return Number(this.selectedValue[0]?.split('-')?.[0])
    }

    get selectedMax(): number {
      return Number(this.selectedValue[0]?.split('-')?.[1])
    }

    get value(): Array<number> {
      const isSelectedMinInRange = this.selectedMin > this.min && this.selectedMin < this.max
      const isSelectedMaxInRange = this.selectedMax < this.max && this.selectedMax > this.min
      return [isSelectedMinInRange ? this.selectedMin : this.min, isSelectedMaxInRange ? this.selectedMax : this.max]
    }

    onCollapseToggle() {
      this.isCollapsed = !this.isCollapsed
      this.$emit('isCollapsed', this.isCollapsed)
    }

    onRangeValueChanged(newRangeValues: Array<Number>) {
      const isValid: boolean = this.validateInputValue(newRangeValues)
      if (isValid) {
        this.$emit('input', {
          ...this.filter,
          filterValue: `${newRangeValues[0]}-${newRangeValues[1]}`,
        } as any)
      }
    }

    validateInputValue(value: Array<Number>): boolean {
      const checkMin = value[0] >= this.min
      const checkMax = this.max >= value[1]
      const checkMinLessMax = this.min < this.max
      const checkValuesOrder = value[0] <= value[1]
      return checkMin && checkMax && checkMinLessMax && checkValuesOrder
    }

    onMinValueChanged(newMinValue: number) {
      return this.onRangeValueChanged([newMinValue, this.value[1]])
    }

    onMaxValueChanged(newMaxValue: number) {
      return this.onRangeValueChanged([this.value[0], newMaxValue])
    }

    mounted() {
      if (this.filter.expanded) this.onCollapseToggle()
    }
  }
